import React from 'react'

export default function About() {
  return (
    <>
      <div className='text-center'>
        <h2 className='animate__animated animate__backInUp'>Registeration <span className='text-danger'>Method</span> </h2>
        <div className='container text-center text-warning w-50 animate__animated animate__fadeInRight' style={{ border: "1px solid black" }}></div>
      </div>

      <div className='container'>
        <div className='row'>
          <div className=' col-12 col-md-6 mt-5 animate__animated animate__backInUp'>
            <th>1.</th>
            <tr>Enter your phone number</tr>
            <th>2.</th>

            <tr>Enter your password</tr>
            <th>3.</th>

            <tr>Press Register button</tr>
            <th>4.</th>

            <tr>Remember your password</tr>
            <th>5.</th>

            <tr>Click on check mark is compulsory</tr>


          </div>

          <div className='col-12 col-md-6 mt-5'>
            <img  className="rounded mx-auto d-block  shadow-lg p-1 mb-5 bg-white rounded animate__animated animate__swing animate__delay-1s" id='responsive' src="Img5.png" alt="Img" />
          </div>
        </div>

      </div>

      <div className='text-center mt-4'>
        <h2 className='animate__animated animate__backInUp'>Deposit <span className='text-danger'>Method</span></h2>
        <div className='container text-center text-warning w-50 animate__animated animate__fadeInRight' style={{ border: "1px solid black" }}></div>
      </div>

      <div className='container'>
        <div className='row'>
          <div className=' col-12 col-md-6 mt-5'>
            <th>1.</th>
            <tr>Choose Deposit method</tr>
            <th>2.</th>

            <tr>write amount how much you want deposit</tr>
            <th>3.</th>

            <tr>Press Register button</tr>
            <th>4. <span className='text-danger'>Note!</span></th>

            <tr>Remember that Easypaisa and Jazzcash are easiest way for deposit</tr>
            <th>5.</th>

            <tr>You can claim bouns on every deposit</tr>


          </div>

          <div className='col-12 col-md-6 mt-5'>
            <img  className="rounded mx-auto d-block  shadow-lg p-1 mb-5 bg-white rounded" id='responsive' src="Img3.png" alt="Img" />
          </div>
        </div>

      </div>



      <div className='text-center mt-4'>
        <h2 className='animate__animated animate__backInUp'>Withdraw <span className='text-danger'>Method</span></h2>
        <div className='container text-center text-warning w-50 animate__animated animate__fadeInRight' style={{ border: "1px solid black" }}></div>
      </div>



      <div className='container'>
        <div className='row'>
          <div className=' col-12 col-md-6 mt-5'>
            <th>1.</th>
            <tr>Write amount how much u want Withdraw</tr>
            <th>2.</th>

            <tr>Withdrawl will be successful in 10 to 20 Minutes </tr>



          </div>

          <div className='col-12 col-md-6 mt-5'>
            <img  className="rounded mx-auto d-block  shadow-lg p-1 mb-5 bg-white rounded" id='responsive' src="Img4.png" alt="Img" />
          </div>
        </div>

      </div>



      <div className='text-center mt-4'>
        <h2 className='animate__animated animate__backInUp'>Play <span className='text-danger'>Method</span></h2>
        <div className='container text-center text-warning w-50 animate__animated animate__fadeInRight' style={{ border: "1px solid black" }}></div>
      </div>




      <div className='container'>
        <div className='row'>
          <div className=' col-12 col-md-6 mt-5'>
            <th>1.</th>
            <tr>Here You will choose whether you want <br />bet big OR small</tr>
            <th>2.</th>

            <tr>Bet as much as you like this will double <br />your profit </tr>
            <th>3.</th>
            <tr>You can choose Number , Big Small and Color</tr>
            <th>4. <span className='text-danger'>Note!</span></th>
            <tr>Remember You cannot bet on both big and samll at the same time</tr>

          </div>

          <div className='col-12 col-md-6 mt-5'>
            <img  className="rounded mx-auto d-block  shadow-lg p-1 mb-5 bg-white rounded" id='responsive' src="Img6.png" alt="Img" />
          </div>
        </div>

      </div>

     



    </>
  )
}
